import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { ThemeToggle } from "@/components/ThemeToggle";
import { api, errMsg } from "@/lib/api";

export default function LeadForm() {
  const { fid } = useParams();
  const [params] = useSearchParams();
  const [form, setForm] = useState(null);
  const [f, setF] = useState({ name: "", email: "", phone: "", company: "", message: "" });
  const [consent, setConsent] = useState(false);
  const [done, setDone] = useState(false);
  useEffect(() => { api.get(`/public/forms/${fid}`).then((r) => setForm(r.data)).catch(() => setForm(false)); }, [fid]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post(`/public/forms/${fid}`, { ...f, consent, content_id: params.get("c") }); setDone(true); } catch (err) { toast.error(errMsg(err)); }
  };
  if (form === false) return <div className="min-h-screen flex items-center justify-center">Form not found</div>;
  return (
    <div className="min-h-screen flex items-center justify-center p-6 relative" data-testid="lead-form-page">
      <div className="absolute top-4 right-4"><ThemeToggle /></div>
      <div className="w-full max-w-lg card-box p-8">
        {!form ? <div className="h-64 animate-pulse bg-muted rounded-xl" /> : done ? (
          <div data-testid="lead-form-success"><h1 className="text-3xl font-bold">Thank you!</h1><p className="mt-3 text-muted-foreground">{form.company_name} will be in touch soon.</p></div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div className="eyebrow">{form.company_name}</div>
            <h1 className="text-3xl font-bold">{form.heading}</h1>
            <p className="text-muted-foreground">{form.subheading}</p>
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="space-y-2"><Label>Name *</Label><Input required value={f.name} onChange={set("name")} data-testid="lf-name" /></div>
              <div className="space-y-2"><Label>Email *</Label><Input required type="email" value={f.email} onChange={set("email")} data-testid="lf-email" /></div>
              <div className="space-y-2"><Label>Phone</Label><Input value={f.phone} onChange={set("phone")} data-testid="lf-phone" /></div>
              <div className="space-y-2"><Label>Company</Label><Input value={f.company} onChange={set("company")} data-testid="lf-company" /></div>
            </div>
            <div className="space-y-2"><Label>Message</Label><Textarea rows={4} value={f.message} onChange={set("message")} data-testid="lf-message" /></div>
            <label className="flex items-start gap-3 text-xs text-muted-foreground"><Checkbox checked={consent} onCheckedChange={(v) => setConsent(!!v)} data-testid="lf-consent" className="mt-0.5" />I agree that {form.company_name} may contact me about my enquiry and process my data for this purpose (GDPR).</label>
            <button disabled={!consent} className="btn-brand w-full disabled:opacity-50" data-testid="lf-submit">Submit</button>
            <p className="text-[10px] text-center text-muted-foreground">Powered by Sliance</p>
          </form>
        )}
      </div>
    </div>
  );
}
